module.exports = __webpack_public_path__ + "static/img/title-banner1-type4.56a89d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/5/title-banner1-type4.png
// module id = MtW3
// module chunks = 1